import {SET_SELECTED_ITEMS_TO_PRINT} from './type';

const setSelectedItemsToPrint = (selectedItems) => (dispatch, getState, api) => {
    dispatch({type: SET_SELECTED_ITEMS_TO_PRINT, selectedItems}) 
}

export default setSelectedItemsToPrint;